module.exports = __webpack_public_path__ + "static/media/34DSS9.1c6c7863.jpg";